<mat-nav-list class="sd_bar">
  <div class="logo-brand">
    <figure class="logo">
      <img [src]="assetsConst.logo" alt="logo" />
    </figure>
    <button (click)="toggleSidenav()" class="btnn btn_close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  @for (item of sideBar(); track $index) {
    @if (item.isView) {
      @if (!item.isSubMenu) {
        <mat-list-item (click)="toggleSidenav()" [routerLink]="item.path" routerLinkActive="active">
          <figure [matTooltip]="item.text | translate" class="sd_cn">
            <img [src]="item.img" alt="" />
          </figure>
          <div class="sidenav-item">
            <h5 class="lead">{{ item.text | translate }}</h5>
          </div>
        </mat-list-item>
      }
    }
  }
</mat-nav-list>
